import { formattedCentsNumber } from "source/giving/utils/money"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { extractMessagesFrom } from "../stores/validations"
import { Designation, ValidationErrorMessage, ValidationErrors } from "../types"
import { designationTotalCents } from "../utils/designationTotal"
import { BigCurrencyInput } from "./display/BigCurrencyInput"

export function AmountInput({
  designations,
  errors,
}: {
  designations: Designation[]
  errors: ValidationErrors
}) {
  if (designations.length > 1) {
    const errorMessages = errors.totalAmount || []
    return (
      <ReadOnlyTotalDesignationAmount {...{ designations, errorMessages }} />
    )
  } else {
    const designation = designations[0]
    const errorMessages = extractMessagesFrom(
      errors,
      "totalAmount",
      `designation_${designation.fundId}_amount`,
    )

    return <FirstDesignationAmountInput {...{ designation, errorMessages }} />
  }
}

type FirstDesignationAmountInputProps = {
  designation: Designation
  errorMessages: ValidationErrorMessage[]
}
function FirstDesignationAmountInput(props: FirstDesignationAmountInputProps) {
  const { dispatch, config } = useDonationFormContext()
  const {
    designation: { fundId, amount },
    errorMessages,
  } = props

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: "UPDATE_DESIGNATION_AMOUNT",
      fundId,
      amount: e.target.value,
      config,
    })
  }

  const onBlur = () => dispatch({ type: "INPUT_BLURRED", config })

  const shouldAutoFocus = window.ReactNativeWebView ? false : true
  return (
    <div>
      <BigCurrencyInput
        {...{ amount, onChange, onBlur }}
        errors={errorMessages}
        autoFocus={shouldAutoFocus} // eslint-disable-line jsx-a11y/no-autofocus
      />
    </div>
  )
}

type ReadOnlyTotalDesignationAmountProps = {
  designations: Designation[]
  errorMessages: ValidationErrorMessage[]
}
function ReadOnlyTotalDesignationAmount(
  props: ReadOnlyTotalDesignationAmountProps,
) {
  const { designations, errorMessages } = props
  const amount = designationTotalCents(designations)
  const formattedAmount = formattedCentsNumber(amount)

  return (
    <>
      <BigCurrencyInput
        amount={formattedAmount}
        readOnly={true}
        errors={errorMessages}
      />
    </>
  )
}
